import { render, staticRenderFns } from "./ProfessionEdit.vue?vue&type=template&id=194ff5f0"
import script from "./ProfessionEdit.vue?vue&type=script&lang=js"
export * from "./ProfessionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports